/**
 * TanStack Query hooks for `real-time-click-fraud-detection`.
 * Polls the backend every 5 seconds to keep the live feed fresh.
 */
import { useQuery, type UseQueryResult } from "@tanstack/react-query";
import {
	listFraudEvents,
	realTimeClickFraudDetectionQueryKeys,
	type ListFraudEventsResponse,
} from "./api";

export function useRealTimeClickFraudDetectionQuery(): UseQueryResult<
	ListFraudEventsResponse,
	Error
> {
	return useQuery({
		queryKey: realTimeClickFraudDetectionQueryKeys.list(),
		queryFn: listFraudEvents,
		refetchInterval: 5000,
		refetchIntervalInBackground: false,
	});
}
